export enum PermissionLevel {
  None = 0,
  ReadOnly = 1,
  ReadAndWrite = 2,
  SuperUser = 3,
}

// * Permisos mínimos para acceder a una vista
export enum MinimumPermission {
  // eslint-disable-next-line @typescript-eslint/prefer-literal-enum-member
  ReadOnly = PermissionLevel.ReadOnly,
  // eslint-disable-next-line @typescript-eslint/prefer-literal-enum-member
  ReadAndWrite = PermissionLevel.ReadAndWrite,
  // eslint-disable-next-line @typescript-eslint/prefer-literal-enum-member
  SuperUser = PermissionLevel.SuperUser,
}

export const permissionsToRead = [
  PermissionLevel.ReadOnly,
  PermissionLevel.ReadAndWrite,
  PermissionLevel.SuperUser,
];
export const permissionsToWrite = [
  PermissionLevel.ReadAndWrite,
  PermissionLevel.SuperUser,
];
